import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { isNullOrEmpty } from '@awp/core/utils';
import { ThemeService } from './theme.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./theme.service";
var ThemeGuard = /** @class */ (function () {
    function ThemeGuard(router, themeService) {
        this.router = router;
        this.themeService = themeService;
    }
    ThemeGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        var themeId = route.paramMap.get('themeId');
        if (isNullOrEmpty(themeId)) {
            return this.router.createUrlTree(['page/not-found']);
        }
        return this.themeService.verifyTheme(themeId.toLowerCase())
            .pipe(map(function (p) {
            if (p == null || p === false) {
                return _this.router.createUrlTree(['page/not-found']);
            }
            _this.themeService.setTheme(themeId.toLowerCase());
            return true;
        }));
    };
    ThemeGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ThemeGuard_Factory() { return new ThemeGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.ThemeService)); }, token: ThemeGuard, providedIn: "root" });
    return ThemeGuard;
}());
export { ThemeGuard };
